import envConfig from '@nile/home/src/Config/env';
import { SVGIcon } from '@superops/super-icons';
import React from 'react';
import styled from 'styled-components';
import ChatBackdrop from './ChatBackdrop';

const Logo = styled.div`
  background-image: ${(props) => (props.url ? `url(${props.url})` : 'none')};
  background-size: 100%;
  height: ${(props) => (props.height ? props.height : '64px')};
  width: ${(props) => (props.width ? props.width : '64px')};
  background-repeat: no-repeat;
`;

function Updates(props) {
  return (
    <svg
      width="18"
      height="12"
      viewBox="0 0 18 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.25 0H2.75C2.3125 0 2 0.34375 2 0.75V1H0.75C0.3125 1 0 1.34375 0 1.75V10.25C0 11.2188 0.78125 12 1.75 12H16.5C17.3125 12 18 11.3438 18 10.5V0.75C18 0.34375 17.6562 0 17.25 0ZM1.75 10.5C1.59375 10.5 1.5 10.4062 1.5 10.25V2.5H2V10.25C2 10.4062 1.875 10.5 1.75 10.5ZM9.125 10H4.375C4.15625 10 4 9.84375 4 9.625V9.375C4 9.1875 4.15625 9 4.375 9H9.125C9.3125 9 9.5 9.1875 9.5 9.375V9.625C9.5 9.84375 9.3125 10 9.125 10ZM15.625 10H10.875C10.6562 10 10.5 9.84375 10.5 9.625V9.375C10.5 9.1875 10.6562 9 10.875 9H15.625C15.8125 9 16 9.1875 16 9.375V9.625C16 9.84375 15.8125 10 15.625 10ZM9.125 7H4.375C4.15625 7 4 6.84375 4 6.625V6.375C4 6.1875 4.15625 6 4.375 6H9.125C9.3125 6 9.5 6.1875 9.5 6.375V6.625C9.5 6.84375 9.3125 7 9.125 7ZM15.625 7H10.875C10.6562 7 10.5 6.84375 10.5 6.625V6.375C10.5 6.1875 10.6562 6 10.875 6H15.625C15.8125 6 16 6.1875 16 6.375V6.625C16 6.84375 15.8125 7 15.625 7ZM15.625 4H4.375C4.15625 4 4 3.84375 4 3.625V2.375C4 2.1875 4.15625 2 4.375 2H15.625C15.8125 2 16 2.1875 16 2.375V3.625C16 3.84375 15.8125 4 15.625 4Z"
        fill="black"
        fill-opacity="0.4"
      />
    </svg>
  );
}

function Conversation(props) {
  return (
    <svg
      width="15"
      height="13"
      viewBox="0 0 15 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 0.625C4.11719 0.625 1 3.19531 1 6.3125C1 7.67969 1.57422 8.91016 2.55859 9.89453C2.20312 11.2891 1.05469 12.4922 1.05469 12.5195C1 12.5742 0.972656 12.6836 1 12.7656C1.05469 12.8477 1.10938 12.875 1.21875 12.875C3.02344 12.875 4.39062 12.0273 5.04688 11.4805C5.94922 11.8086 6.93359 12 8 12C11.8555 12 15 9.45703 15 6.3125C15 3.19531 11.8555 0.625 8 0.625Z"
        fill="black"
        fill-opacity="0.4"
      />
    </svg>
  );
}

function Notes(props) {
  return (
    <svg
      width="11"
      height="15"
      viewBox="0 0 11 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.125 4.46875V0.75H0.65625C0.273438 0.75 0 1.05078 0 1.40625V14.0938C0 14.4766 0.273438 14.75 0.65625 14.75H9.84375C10.1992 14.75 10.5 14.4766 10.5 14.0938V5.125H6.78125C6.39844 5.125 6.125 4.85156 6.125 4.46875ZM10.5 4.08594C10.5 3.92188 10.418 3.75781 10.3086 3.62109L7.62891 0.941406C7.49219 0.832031 7.32812 0.75 7.16406 0.75H7V4.25H10.5V4.08594Z"
        fill="black"
        fill-opacity="0.4"
      />
    </svg>
  );
}

function Attachments(props) {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.5"
        d="M2.17578 13.5195C3.78906 15.1602 6.41406 15.1875 8.05469 13.5195L12.7578 8.70703C12.9219 8.54297 12.9219 8.26953 12.7305 8.10547L12.1016 7.47656C11.9375 7.3125 11.6641 7.3125 11.5 7.47656L6.79688 12.2891C5.86719 13.2461 4.36328 13.2461 3.43359 12.2891C2.50391 11.332 2.50391 9.74609 3.46094 8.78906L9.20312 2.91016C9.72266 2.39062 10.5703 2.39062 11.0898 2.91016C11.6094 3.45703 11.6094 4.35938 11.0898 4.90625L6.08594 10.0195C5.97656 10.1289 5.78516 10.1289 5.64844 10.0195C5.53906 9.88281 5.53906 9.63672 5.67578 9.5L9.61328 5.50781C9.77734 5.31641 9.77734 5.04297 9.58594 4.87891L8.98438 4.27734C8.79297 4.08594 8.51953 4.11328 8.35547 4.27734L4.41797 8.29688C3.625 9.08984 3.59766 10.4023 4.39062 11.2227C5.18359 12.0703 6.52344 12.0703 7.34375 11.25L12.3477 6.13672C13.5508 4.90625 13.5234 2.91016 12.3477 1.67969C11.1172 0.449219 9.14844 0.449219 7.94531 1.67969L2.20312 7.55859C0.589844 9.19922 0.5625 11.8516 2.17578 13.5195Z"
        fill="#0D0015"
      />
    </svg>
  );
}

function Invoices(props) {
  return (
    <svg
      width="18"
      height="11"
      viewBox="0 0 18 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.5"
        d="M9.625 6.625H9.1875V4.21875C9.1875 4.10938 9.07812 4 8.96875 4H8.58594C8.44922 4 8.33984 4.05469 8.23047 4.13672L7.79297 4.41016C7.73828 4.4375 7.71094 4.51953 7.71094 4.57422C7.71094 4.62891 7.71094 4.68359 7.73828 4.71094L7.98438 5.06641C8.01172 5.12109 8.09375 5.17578 8.17578 5.17578C8.20312 5.17578 8.25781 5.14844 8.28516 5.12109H8.3125V6.625H7.875C7.73828 6.625 7.65625 6.73438 7.65625 6.84375V7.28125C7.65625 7.41797 7.73828 7.5 7.875 7.5H9.625C9.73438 7.5 9.84375 7.41797 9.84375 7.28125V6.84375C9.84375 6.73438 9.73438 6.625 9.625 6.625ZM16.625 0.5H0.875C0.382812 0.5 0 0.910156 0 1.375V10.125C0 10.6172 0.382812 11 0.875 11H16.625C17.0898 11 17.5 10.6172 17.5 10.125V1.375C17.5 0.910156 17.0898 0.5 16.625 0.5ZM1.3125 9.6875V7.9375C2.26953 7.9375 3.0625 8.73047 3.0625 9.6875H1.3125ZM1.3125 3.5625V1.8125H3.0625C3.0625 2.79688 2.26953 3.5625 1.3125 3.5625ZM8.75 8.8125C7.27344 8.8125 6.125 7.44531 6.125 5.75C6.125 4.08203 7.27344 2.6875 8.75 2.6875C10.1992 2.6875 11.375 4.08203 11.375 5.75C11.375 7.44531 10.1992 8.8125 8.75 8.8125ZM16.1875 9.6875H14.4375C14.4375 8.73047 15.2031 7.9375 16.1875 7.9375V9.6875ZM16.1875 3.5625C15.2031 3.5625 14.4375 2.79688 14.4375 1.8125H16.1875V3.5625Z"
        fill="#0D0015"
      />
    </svg>
  );
}

function Tasks(props) {
  return (
    <svg
      width="11"
      height="15"
      viewBox="0 0 11 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.1875 2.5H7C7 1.54297 6.20703 0.75 5.25 0.75C4.26562 0.75 3.5 1.54297 3.5 2.5H1.3125C0.574219 2.5 0 3.10156 0 3.8125V13.4375C0 14.1758 0.574219 14.75 1.3125 14.75H9.1875C9.89844 14.75 10.5 14.1758 10.5 13.4375V3.8125C10.5 3.10156 9.89844 2.5 9.1875 2.5ZM5.25 1.84375C5.60547 1.84375 5.90625 2.14453 5.90625 2.5C5.90625 2.88281 5.60547 3.15625 5.25 3.15625C4.86719 3.15625 4.59375 2.88281 4.59375 2.5C4.59375 2.14453 4.86719 1.84375 5.25 1.84375ZM8.55859 8.1875L4.64844 12.0703C4.51172 12.207 4.29297 12.207 4.18359 12.0703L1.91406 9.80078C1.77734 9.66406 1.80469 9.44531 1.91406 9.33594L2.70703 8.54297C2.81641 8.43359 3.03516 8.43359 3.17188 8.57031L4.42969 9.82812L7.32812 6.95703C7.4375 6.82031 7.65625 6.82031 7.79297 6.95703L8.55859 7.72266C8.69531 7.85938 8.66797 8.07812 8.55859 8.1875Z"
        fill="#A3A3A3"
      />
    </svg>
  );
}

function TabsCloseIcon({ height, width }) {
  return (
    <svg
      width={width || '8'}
      height={height || '8'}
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 1L1 7"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7 7L1 1"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

function RefreshIcon({ height, width }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 16.6691C12.4428 16.6693 14.6903 15.334 15.8583 13.1885"
        stroke="#323232"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.6694 10C16.6694 6.31658 13.6834 3.33057 10 3.33057"
        stroke="#323232"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.99987 3.33057C7.55705 3.33036 5.30958 4.66567 4.1416 6.81118"
        stroke="#323232"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.33057 10C3.33057 13.6834 6.31658 16.6694 10 16.6694"
        stroke="#323232"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.1416 6.81088C5.59949 4.13169 8.68916 2.78294 11.6451 3.53534C14.601 4.28774 16.6698 6.94955 16.6693 9.99971"
        stroke="#323232"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.33057 10C3.3301 13.0502 5.39892 15.712 8.35482 16.4644C11.3107 17.2168 14.4004 15.868 15.8583 13.1888"
        stroke="#323232"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.70439 6.81118H3.75732V3.86328"
        stroke="#323232"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.2954 13.1885H16.2425V16.1364"
        stroke="#323232"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

function MoreTabsIcon(props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 11.001L12 14.001L9 11.001"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <rect
        x="2.99609"
        y="2.99658"
        width="18.0075"
        height="18.0075"
        rx="5"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

function ScriptsTabIcon(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.4766 16.6668C16.5282 16.6668 17.3816 15.8143 17.3816 14.7618V10.9527L18.3341 10.0002L17.3816 9.04766V5.2385C17.3816 4.186 16.5291 3.3335 15.4766 3.3335"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.5 14.1668L12.5 5.8335"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.52351 3.3335C3.47101 3.3335 2.61852 4.186 2.61852 5.2385V9.04766L1.66602 10.0002L2.61852 10.9527V14.7618C2.61852 15.8143 3.47101 16.6668 4.52351 16.6668"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

function CommunityScriptTabIcon({ width = '24px', height = '24px' }) {
  return (
    <div className="colorIcon ignoreOverride">
      <svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="3.33337"
          y="4.16675"
          width="13.3333"
          height="11.6667"
          rx="2"
          fill="url(#paint0_linear_234_2013)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.8334 8.3335L9.16675 11.6668Z"
          fill="url(#paint1_linear_234_2013)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.0198 7.96083C11.2256 8.06374 11.309 8.31402 11.2061 8.51984L9.53944 11.8532C9.43652 12.059 9.18624 12.1424 8.98042 12.0395C8.77459 11.9366 8.69117 11.6863 8.79408 11.4805L10.4607 8.14717C10.5637 7.94134 10.8139 7.85792 11.0198 7.96083Z"
          fill="#1C0558"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.622 8.45553C12.7848 8.29282 13.0486 8.29282 13.2113 8.45553L14.3011 9.54529C14.5523 9.79651 14.5523 10.2038 14.3011 10.455L13.2113 11.5448C13.0486 11.7075 12.7848 11.7075 12.622 11.5448C12.4593 11.3821 12.4593 11.1183 12.622 10.9555L13.5774 10.0002L12.622 9.04479C12.4593 8.88207 12.4593 8.61825 12.622 8.45553Z"
          fill="#1C0558"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.37805 8.45553C7.54076 8.61825 7.54076 8.88207 7.37805 9.04479L6.42267 10.0002L7.37805 10.9555C7.54076 11.1183 7.54076 11.3821 7.37805 11.5448C7.21533 11.7075 6.95151 11.7075 6.78879 11.5448L5.69903 10.455C5.44782 10.2038 5.44782 9.79651 5.69903 9.54529L6.78879 8.45553C6.95151 8.29282 7.21533 8.29282 7.37805 8.45553Z"
          fill="#1C0558"
        />
        <defs>
          <linearGradient
            id="paint0_linear_234_2013"
            x1="10"
            y1="4.16675"
            x2="10"
            y2="15.8334"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#A680FF" />
            <stop offset="1" stop-color="#17FF6D" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_234_2013"
            x1="10.1825"
            y1="8.3335"
            x2="10.1825"
            y2="11.9594"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#9C74C8" />
            <stop offset="1" stop-color="#8451BF" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
}

function AssetsTabIcon(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.3593 14.0276H3.63932C2.71849 14.0276 1.97266 13.2818 1.97266 12.3609V4.21842C1.97266 3.29759 2.71849 2.55176 3.63932 2.55176H16.3585C17.2793 2.55176 18.0252 3.29759 18.0252 4.21842V12.3618C18.026 13.2818 17.2793 14.0276 16.3593 14.0276Z"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.1543 17.5002C7.38263 16.3894 12.6176 16.3894 15.8468 17.5002"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

function ChartTabIcon(props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.6667 12V18.6667"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.2487 14.2251V18.6668"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.33268 16.1665V18.6665"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.7487 13.3335V18.6668"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.2825 9.09071C15.852 9.66023 15.852 10.5836 15.2825 11.1531C14.713 11.7226 13.7896 11.7226 13.2201 11.1531C12.6506 10.5836 12.6506 9.66022 13.2201 9.09071C13.7896 8.5212 14.713 8.5212 15.2825 9.09071"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.7844 5.33827C20.354 5.90778 20.354 6.83115 19.7844 7.40066C19.2149 7.97018 18.2916 7.97018 17.7221 7.40066C17.1525 6.83115 17.1525 5.90778 17.7221 5.33827C18.2916 4.76875 19.2149 4.76875 19.7844 5.33827"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.27664 9.83583C6.84615 10.4053 6.84615 11.3287 6.27664 11.8982C5.70712 12.4677 4.78375 12.4677 4.21425 11.8982C3.64473 11.3287 3.64473 10.4053 4.21425 9.83583C4.78376 9.26631 5.70713 9.26631 6.27664 9.83583"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.7805 6.08387C11.3501 6.65339 11.3501 7.57676 10.7805 8.14627C10.211 8.71578 9.28766 8.71578 8.71815 8.14627C8.14864 7.57675 8.14864 6.65338 8.71815 6.08387C9.28767 5.51436 10.211 5.51436 10.7805 6.08387"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.6422 7.30029L15.3672 9.19196"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.032 9.31696L10.957 7.92529"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.36719 9.94196L8.63385 8.05029"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

function ReportTabIcon(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.6667 14.167H3.33333C2.87333 14.167 2.5 13.7937 2.5 13.3337V12.5003C2.5 12.0403 2.87333 11.667 3.33333 11.667H16.6667C17.1267 11.667 17.5 12.0403 17.5 12.5003V13.3337C17.5 13.7937 17.1267 14.167 16.6667 14.167Z"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.16732 3.3335C3.70732 3.3335 3.33398 3.70683 3.33398 4.16683V11.6668H16.6673V4.16683C16.6673 3.70683 16.294 3.3335 15.834 3.3335"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.3333 17.5003L12.5 14.167"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.66602 17.5003L7.49935 14.167"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.334 4.5835H6.66732C6.20732 4.5835 5.83398 4.21016 5.83398 3.75016V2.91683C5.83398 2.45683 6.20732 2.0835 6.66732 2.0835H13.334C13.794 2.0835 14.1673 2.45683 14.1673 2.91683V3.75016C14.1673 4.21016 13.794 4.5835 13.334 4.5835Z"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.8327 3.33366H14.166"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.83268 3.33366H4.16602"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

function HomeTabIcon(props) {
  return (
    <div className="colorIcon ignoreOverride">
      <SVGIcon name="home" size="lg" />
    </div>
  );
}

function NetworkMonitorIcon({ name = 'NetworkMonitoring' }) {
  return <SVGIcon name={name} />;
}

function ProjectTabIcon(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.8333 17.0833H4.16667C3.24583 17.0833 2.5 16.3375 2.5 15.4167V7.91667C2.5 6.99583 3.24583 6.25 4.16667 6.25H15.8333C16.7542 6.25 17.5 6.99583 17.5 7.91667V15.4167C17.5 16.3375 16.7542 17.0833 15.8333 17.0833Z"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.4782 6.24984V4.58317C13.4782 3.66234 12.7323 2.9165 11.8115 2.9165H8.18815C7.26732 2.9165 6.52148 3.66234 6.52148 4.58317V6.24984"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.5 7.9165L7.7925 11.409C8.065 11.589 8.38417 11.6848 8.71083 11.6848H11.2892C11.6158 11.6848 11.935 11.589 12.2075 11.409L17.5 7.9165"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

function ClientHomeTabIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M23.149 9.68221L16.149 4.23738C14.8855 3.25388 13.1157 3.25388 11.851 4.23738L4.851 9.68221C3.99817 10.3449 3.5 11.3645 3.5 12.4449V21C3.5 22.9332 5.06683 24.5 7 24.5H21C22.9332 24.5 24.5 22.9332 24.5 21V12.4449C24.5 11.3645 24.0018 10.3449 23.149 9.68221Z"
        stroke="black"
        stroke-width="1.5"
      />
      <path
        d="M10.5 19.8333H17.5"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

function TicketTabIcon(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.49805 7.33286H11.5001"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.49805 10.8338H8.99909"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.3327 12.6965V14.9998C18.3327 15.4598 17.9593 15.8332 17.4993 15.8332H2.49935C2.03935 15.8332 1.66602 15.4598 1.66602 14.9998V12.6965C1.66602 12.5757 1.73435 12.4657 1.84185 12.4115V12.4115C2.75602 11.9548 3.33268 11.0215 3.33268 9.99984V9.99984C3.33268 8.97817 2.75518 8.04484 1.84185 7.58817V7.58817C1.73435 7.534 1.66602 7.424 1.66602 7.30317V4.99984C1.66602 4.53984 2.03935 4.1665 2.49935 4.1665H17.4993C17.9593 4.1665 18.3327 4.53984 18.3327 4.99984V7.30317C18.3327 7.424 18.2643 7.534 18.1568 7.58817L18.1202 7.60734C17.2269 8.07067 16.666 8.99317 16.666 9.99984V9.99984C16.666 11.0207 17.2427 11.9548 18.156 12.4115H18.1568C18.2643 12.4657 18.3327 12.5757 18.3327 12.6965Z"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

function ClientTabIcon(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.51628 9.0752V17.4085"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.4831 9.0752V17.4085"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.8518 17.4075V13.7042C11.8518 12.6817 11.0226 11.8525 10.0001 11.8525C8.9776 11.8525 8.14844 12.6817 8.14844 13.7042V17.4075"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.66602 17.4079H18.3327"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.58512 9.07444C2.17012 9.06444 1.24762 7.66361 1.86096 6.45611L3.29012 3.64194C3.61596 3.00027 4.30096 2.59277 5.05262 2.59277H14.9493C15.701 2.59277 16.386 3.00027 16.7118 3.64194L18.1418 6.45611C18.7551 7.66361 17.8326 9.06444 16.4176 9.07444C15.2368 9.07444 14.2793 8.26777 14.2793 7.27194V7.23194C14.2793 8.24944 13.3218 9.07444 12.141 9.07444C10.9601 9.07444 10.0026 8.24944 10.0026 7.23194C10.0026 8.24944 9.04512 9.07444 7.86429 9.07444C6.68346 9.07444 5.72596 8.24944 5.72596 7.23194V7.27194C5.72346 8.26777 4.76596 9.07444 3.58512 9.07444Z"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

function ITDocsTabIcon(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.3444 5.345L12.9877 2.98833C12.6752 2.67583 12.251 2.5 11.8093 2.5H5.83268C4.91185 2.5 4.16602 3.24583 4.16602 4.16667V15.8333C4.16602 16.7542 4.91185 17.5 5.83268 17.5H14.166C15.0869 17.5 15.8327 16.7542 15.8327 15.8333V6.52333C15.8327 6.08167 15.6569 5.6575 15.3444 5.345V5.345Z"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.8327 6.66667H12.4993C12.0393 6.66667 11.666 6.29333 11.666 5.83333V2.5"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.61523 13.7917H11.3819"
        stroke="black"
        stroke-width="0.7"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.02734 10.6257V9.65234C9.02734 9.384 9.24484 9.1665 9.51318 9.1665H10.4865C10.7548 9.1665 10.9723 9.384 10.9723 9.65234V10.6257C10.9723 10.894 10.7548 11.1115 10.4865 11.1115H9.51318C9.24484 11.1107 9.02734 10.8932 9.02734 10.6257Z"
        stroke="black"
        stroke-width="0.7"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.66602 14.5143V13.541C6.66602 13.2727 6.88352 13.0552 7.15185 13.0552H8.12518C8.39351 13.0552 8.61101 13.2727 8.61101 13.541V14.5143C8.61101 14.7827 8.39351 15.0002 8.12518 15.0002H7.15185C6.88352 15.0002 6.66602 14.7827 6.66602 14.5143Z"
        stroke="black"
        stroke-width="0.7"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.3887 14.5143V13.541C11.3887 13.2727 11.6062 13.0552 11.8745 13.0552H12.8478C13.1162 13.0552 13.3337 13.2727 13.3337 13.541V14.5143C13.3328 14.7827 13.1153 15.0002 12.847 15.0002H11.8737C11.6062 15.0002 11.3887 14.7827 11.3887 14.5143H11.3887Z"
        stroke="black"
        stroke-width="0.7"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.8658 13.0585L10.6074 11.0918"
        stroke="black"
        stroke-width="0.7"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.13281 13.0585L9.39114 11.0918"
        stroke="black"
        stroke-width="0.7"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

function FeedBackIcon(props) {
  return (
    <div className="colorIcon ignoreOverride">
      <SVGIcon name="FeedbackIcon" size="lg" />
    </div>
  );
}

function InsightTabIcon(props) {
  return (
    <div className="colorIcon ignoreOverride">
      <SVGIcon name="OrganizationColoured" size="lg" />
    </div>
  );
}

function ITDocumentationTabIcon(props) {
  return (
    <Logo
      className="module-logo"
      url={`${envConfig.imageRoot}svg/it-documentation-module.svg`}
    />
  );
}

function RequesterTabIcon(params) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.6116 17.5033H3.88584C3.11802 17.5033 2.49609 16.8813 2.49609 16.1135V6.38779C2.49609 5.61997 3.11802 4.99805 3.88584 4.99805H13.6124C14.3794 4.99805 15.0013 5.61997 15.0013 6.38779V16.1143C15.0013 16.8813 14.3794 17.5033 13.6116 17.5033Z"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.2225 8.47116C11.0362 9.28483 11.0362 10.6046 10.2225 11.4191C9.40885 12.2327 8.08913 12.2327 7.27463 11.4191C6.46012 10.6054 6.46096 9.28567 7.27463 8.47116C8.0883 7.65666 9.40802 7.65749 10.2225 8.47116"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.4992 15.364C12.39 15.0898 12.2208 14.843 12.004 14.6421V14.6421C11.638 14.3019 11.1587 14.1135 10.6585 14.1135C9.82477 14.1135 7.67054 14.1135 6.83686 14.1135C6.33665 14.1135 5.85812 14.3028 5.4913 14.6421V14.6421C5.27454 14.843 5.10531 15.0898 4.99609 15.364"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.99609 4.99811V3.88682C4.99609 3.119 5.61802 2.49707 6.38584 2.49707H16.1124C16.8794 2.49707 17.5013 3.119 17.5013 3.88682V13.6134C17.5013 14.3804 16.8794 15.0023 16.1116 15.0023H15.0003"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

function SiteTabIcon(params) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.27344 8.37083V8.2275C4.27344 5.06417 6.8376 2.5 10.0009 2.5V2.5C13.1643 2.5 15.7284 5.06417 15.7284 8.2275V8.37083C15.7284 11.255 12.0768 15.5967 10.6051 17.23C10.2809 17.59 9.72094 17.59 9.39677 17.23C7.9251 15.5967 4.27344 11.255 4.27344 8.37083Z"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.33398 8.29564C8.33398 9.21648 9.07982 9.96231 10.0007 9.96231V9.96231C10.9215 9.96231 11.6673 9.21648 11.6673 8.29564V8.26481C11.6673 7.34398 10.9215 6.59814 10.0007 6.59814V6.59814C9.07982 6.59814 8.33398 7.34398 8.33398 8.26481"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

function NewPatchTabIcon(params) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.81211 16.5801L3.41961 16.1876C2.11794 14.8859 2.11794 12.7751 3.41961 11.4734L11.4729 3.4201C12.7746 2.11843 14.8854 2.11843 16.1871 3.4201L16.5796 3.8126C17.8813 5.11426 17.8813 7.2251 16.5796 8.52677L8.52628 16.5801C7.22461 17.8818 5.11378 17.8818 3.81211 16.5801Z"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 4.8916L15.1083 9.99994"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.40596 9.9269C8.36513 9.88607 8.2993 9.88607 8.2593 9.9269C8.21846 9.96773 8.21846 10.0336 8.2593 10.0744C8.30013 10.1152 8.36596 10.1152 8.4068 10.0744C8.4468 10.0336 8.4468 9.96773 8.40596 9.9269"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.0739 11.5934C10.0331 11.5526 9.96727 11.5526 9.92727 11.5934C9.88643 11.6342 9.88643 11.7001 9.92727 11.7409C9.9681 11.7817 10.0339 11.7817 10.0748 11.7409C10.1148 11.7001 10.1148 11.6342 10.0739 11.5934"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.0739 8.25991C10.0331 8.21908 9.96727 8.21908 9.92727 8.25991C9.88643 8.30074 9.88643 8.36658 9.92727 8.40741C9.9681 8.44824 10.0339 8.44824 10.0748 8.40741C10.1148 8.36658 10.1148 8.30074 10.0739 8.25991"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.7399 9.9269C11.6991 9.88607 11.6333 9.88607 11.5933 9.9269C11.5524 9.96773 11.5524 10.0336 11.5933 10.0744C11.6341 10.1152 11.6999 10.1152 11.7408 10.0744C11.7808 10.0336 11.7808 9.96773 11.7399 9.9269"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.99896 15.1083L4.89062 10"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

function NewAlertTabIcon(params) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.99797 4.35742V4.35742C13.1146 4.35742 15.6405 6.88326 15.6405 9.99992V9.99992C15.6405 13.1166 13.1146 15.6424 9.99797 15.6424V15.6424C6.8813 15.6424 4.35547 13.1166 4.35547 9.99992V9.99992C4.35547 6.88326 6.8813 4.35742 9.99797 4.35742Z"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.9987 10.3134V7.1792"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.99787 12.5392C9.9287 12.5392 9.87287 12.5951 9.8737 12.6642C9.8737 12.7334 9.92953 12.7892 9.9987 12.7892C10.0679 12.7892 10.1237 12.7334 10.1237 12.6642C10.1237 12.5959 10.0679 12.5392 9.99787 12.5392"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.9375 4.79736C19.2525 7.87403 19.2525 12.1249 16.9375 15.2015"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.05461 15.2025C0.73961 12.1258 0.73961 7.87501 3.05461 4.79834"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

function ModuleLogo(props) {
  const { image } = props;
  return (
    <Logo className="module-logo" url={`${envConfig.imageRoot}svg/${image}`} />
  );
}

function Clients(props) {
  return (
    <Logo
      className="module-logo"
      url={`${envConfig.imageRoot}svg/Clients.svg`}
    />
  );
}

function Invoice(props) {
  return (
    <Logo
      className="module-logo"
      url={`${envConfig.imageRoot}svg/Invoice.svg`}
    />
  );
}

function Quotes(props) {
  return (
    <Logo
      className="module-logo"
      url={`${envConfig.imageRoot}svg/Quotes.svg`}
    />
  );
}

function InvoiceAudit(props) {
  return (
    <Logo
      className="module-logo"
      url={`${envConfig.imageRoot}svg/InvoiceAudit.svg`}
    />
  );
}

function ServiceItem(props) {
  return (
    <Logo
      className="module-logo"
      url={`${envConfig.imageRoot}svg/service-item.svg`}
    />
  );
}

function QuickBooks(props) {
  return (
    <Logo
      className="module-logo"
      url={`${envConfig.imageRoot}svg/QuickBooks.svg`}
    />
  );
}
function XeroBlue(props) {
  return (
    <Logo
      className="module-logo"
      url={`${envConfig.imageRoot}svg/XeroBlue.svg`}
    />
  );
}
function Reports(props) {
  return (
    <Logo
      className="module-logo"
      url={`${envConfig.imageRoot}svg/Reports.svg`}
    />
  );
}

function Charts(props) {
  return (
    <Logo
      className="module-logo"
      url={`${envConfig.imageRoot}svg/Charts.svg`}
    />
  );
}

function UnkownEmail(props) {
  return (
    <Logo
      className="module-logo"
      url={`${envConfig.imageRoot}svg/Unknown-email.svg`}
    />
  );
}

function Asset(props) {
  return (
    <div className="colorIcon ignoreOverride">
      <SVGIcon name="AssetModule" size="lg" />
    </div>
  );
}

function MyWorkspace(props) {
  return (
    <div className="colorIcon ignoreOverride">
      <SVGIcon name="workspace" size="lg" />
    </div>
  );
}

function ProductOnboard(props) {
  return (
    <Logo
      className="module-logo"
      url={`${envConfig.imageRoot}svg/product-onboarding.svg`}
    />
  );
}

function TimesheetData(props) {
  return (
    <Logo
      className="module-logo"
      url={`${envConfig.imageRoot}svg/timesheet.svg`}
    />
  );
}

function SchedulingData(props) {
  return (
    <div className="colorIcon ignoreOverride">
      <SVGIcon name="SchedulingModule" size="lg" />
    </div>
  );
}

function MigrateData(props) {
  return (
    <Logo
      className="module-logo"
      url={`${envConfig.imageRoot}svg/migrate-data.svg`}
    />
  );
}

function Project(props) {
  return (
    <Logo
      className="module-logo"
      url={`${envConfig.imageRoot}svg/project.svg`}
    />
  );
}

function Ticket(props) {
  return (
    <Logo
      className="module-logo"
      url={`${envConfig.imageRoot}svg/ticket.svg`}
    />
  );
}
function Task(props) {
  return (
    <Logo className="module-logo" url={`${envConfig.imageRoot}svg/task.svg`} />
  );
}

function Script(props) {
  return (
    <Logo
      className="module-logo"
      url={`${envConfig.imageRoot}svg/script.svg`}
    />
  );
}

function ItDocumantation(props) {
  return (
    <Logo
      className="module-logo"
      url={`${envConfig.imageRoot}svg/it-documentation-module.svg`}
    />
  );
}

function Alert(props) {
  return (
    <Logo className="module-logo" url={`${envConfig.imageRoot}svg/alert.svg`} />
  );
}
function Patch(props) {
  return (
    <Logo className="module-logo" url={`${envConfig.imageRoot}svg/patch.svg`} />
  );
}

function ContractTemplate(props) {
  return (
    <Logo
      className="module-logo"
      url={`${envConfig.imageRoot}svg/contracts-template.svg`}
    />
  );
}

function Search(props) {
  return (
    <div className="fx center">
      <SVGIcon name="Search" size="lg" />
    </div>
  );
}

function MailTabIcon(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.8333 15.8176H4.16667C3.24583 15.8176 2.5 15.0718 2.5 14.1509V5.84928C2.5 4.92845 3.24583 4.18262 4.16667 4.18262H15.8333C16.7542 4.18262 17.5 4.92845 17.5 5.84928V14.1518C17.5 15.0718 16.7542 15.8176 15.8333 15.8176V15.8176Z"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.1673 7.5L10.0007 10L5.83398 7.5"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

function SettingsIcon(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.0611 11.9378C17.2001 13.0768 17.2001 14.9235 16.0611 16.0626C14.9221 17.2016 13.0753 17.2016 11.9363 16.0626C10.7973 14.9235 10.7973 13.0768 11.9363 11.9378C13.0753 10.7987 14.9221 10.7987 16.0611 11.9378"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.323 4.80674L18.0032 5.03307C18.6262 5.24074 19.0474 5.82407 19.0474 6.4809V7.4574C19.0474 8.28807 19.71 8.9659 20.5407 8.9834L21.5184 9.0044C22.0842 9.01607 22.5975 9.34157 22.8507 9.8479L23.1715 10.4896C23.4655 11.0776 23.35 11.7869 22.8857 12.2512L22.195 12.9419C21.6082 13.5287 21.5977 14.4772 22.1717 15.0769L22.8484 15.7839C23.2404 16.1934 23.3734 16.7849 23.1937 17.3227L22.9674 18.0029C22.7597 18.6259 22.1764 19.0471 21.5195 19.0471H20.543C19.7124 19.0471 19.0345 19.7097 19.017 20.5404L18.996 21.5181C18.9844 22.0839 18.6589 22.5972 18.1525 22.8504L17.5109 23.1712C16.9229 23.4652 16.2135 23.3497 15.7492 22.8854L15.0585 22.1947C14.4717 21.6079 13.5232 21.5974 12.9235 22.1714L12.2165 22.8481C11.807 23.2401 11.2155 23.3731 10.6777 23.1934L9.99753 22.9671C9.37453 22.7594 8.95337 22.1761 8.95337 21.5192V20.5427C8.95337 19.7121 8.2907 19.0342 7.46003 19.0167L6.48237 18.9957C5.91653 18.9841 5.4032 18.6586 5.15003 18.1522L4.8292 17.5106C4.5352 16.9226 4.6507 16.2132 5.11503 15.7489L5.8057 15.0582C6.39253 14.4714 6.40303 13.5229 5.82903 12.9232L5.15237 12.2162C4.7592 11.8056 4.6262 11.2129 4.80587 10.6762L5.0322 9.99607C5.23987 9.37307 5.8232 8.9519 6.48003 8.9519H7.45653C8.2872 8.9519 8.96503 8.28924 8.98253 7.45857L9.00353 6.4809C9.01753 5.91507 9.34187 5.40174 9.8482 5.14857L10.4899 4.82774C11.0779 4.53374 11.7872 4.64924 12.2515 5.11357L12.9422 5.80424C13.529 6.39107 14.4775 6.40157 15.0772 5.82757L15.7842 5.1509C16.1937 4.76007 16.7864 4.62707 17.323 4.80674V4.80674Z"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

function Close(props) {
  const { height = '26', width = '26' } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="1"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.8611 12.9973L25.616 2.23903C26.128 1.72682 26.128 0.896367 25.616 0.384157C25.1039 -0.128052 24.2737 -0.128052 23.7617 0.384157L13.0069 11.1424L2.25202 0.402706C1.73998 -0.109504 0.909789 -0.109504 0.397744 0.402706C-0.114302 0.914916 -0.114302 1.74537 0.397744 2.25758L11.1526 12.9973L0.397744 23.7556C0.143773 23.9972 0 24.3324 0 24.683C0 25.0336 0.143773 25.3689 0.397744 25.6105C0.641324 25.8584 0.977572 25.9929 1.32488 25.9814C1.6737 25.9815 2.00785 25.8411 2.25202 25.5919L13.0069 14.8522L23.7617 25.6105C24.0059 25.8596 24.34 26 24.6888 26C25.0325 26.0015 25.3615 25.8604 25.5974 25.6105C25.8514 25.3689 25.9952 25.0336 25.9952 24.683C25.9952 24.3324 25.8514 23.9972 25.5974 23.7556L14.8611 12.9973Z"
        fill="#686868"
      />
    </svg>
  );
}

function SLAOverdueTimer() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.33398 14.9997H11.6673"
        stroke="#e72f23"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.1492 2.5H5.85091C5.39091 2.5 5.01758 2.87333 5.01758 3.33333V5.315C5.01758 5.66583 5.12841 6.00833 5.33424 6.2925L8.01758 10L5.33424 13.7075C5.12841 13.9917 5.01758 14.3342 5.01758 14.685V16.6667C5.01758 17.1267 5.39091 17.5 5.85091 17.5H14.1484C14.6084 17.5 14.9817 17.1267 14.9817 16.6667V14.715C14.9817 14.345 14.8584 13.9858 14.6317 13.6933L11.7676 10L14.6326 6.30583C14.8592 6.01333 14.9826 5.65417 14.9826 5.28417V3.33333C14.9826 2.87333 14.6092 2.5 14.1492 2.5Z"
        stroke="#e72f23"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

function NewAssetTabIcon(params) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.8333 7.4998H10.4408C10.165 7.4998 9.90667 7.36314 9.75167 7.1348L8.58083 5.41397C8.42583 5.18647 8.16833 5.0498 7.8925 5.0498H4.16667C3.24583 5.0498 2.5 5.79564 2.5 6.71647V15.8331C2.5 16.754 3.24583 17.4998 4.16667 17.4998H15.8333C16.7542 17.4998 17.5 16.754 17.5 15.8331V9.16647C17.5 8.24647 16.7542 7.4998 15.8333 7.4998Z"
        stroke="#323232"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.5 15.8331V9.16647C17.5 8.24647 16.7542 7.49981 15.8333 7.49981H10.4408C10.165 7.49981 9.90667 7.36314 9.75167 7.13481L8.58083 5.41397C8.42583 5.18647 8.16833 5.0498 7.8925 5.0498H4.16667C3.24583 5.0498 2.5 5.79564 2.5 6.71647V15.8331"
        stroke="#323232"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.8327 4.95H12.1069C11.831 4.95 11.5727 4.81333 11.4177 4.585L10.2468 2.86417C10.0918 2.63667 9.83435 2.5 9.55852 2.5H4.16602"
        stroke="#323232"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

function Approvals() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.2996 4.20264L8.00297 10.4993L4.85547 7.35097"
        stroke="#323232"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.5 8C15.5 12.1425 12.1425 15.5 8 15.5C3.8575 15.5 0.5 12.1425 0.5 8C0.5 3.8575 3.8575 0.5 8 0.5C9.21083 0.5 10.3508 0.794167 11.3633 1.30333"
        stroke="#323232"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

function WindowsIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.5592 17.06L3.8925 15.1158C3.08917 14.9816 2.5 14.2866 2.5 13.4716V6.52829C2.5 5.71329 3.08917 5.01829 3.8925 4.88412L15.5592 2.93995C16.575 2.77079 17.5 3.55412 17.5 4.58329V15.4166C17.5 16.4458 16.575 17.2291 15.5592 17.06Z"
        stroke="#212121"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.7498 4.07506V15.9251"
        stroke="#212121"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.5 9.88334H17.5"
        stroke="#212121"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

function MacIcon() {
  return (
    <svg
      width="13"
      height="17"
      viewBox="0 0 13 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.65997 6.64C6.1133 6.64 5.26164 6.00333 4.37664 6.00333C3.19997 6.00333 2.1233 6.7225 1.51664 7.7775C0.296638 9.89583 1.20247 13.0258 2.39247 14.7475C2.97664 15.5858 3.66497 16.5292 4.5783 16.4992C5.45414 16.4617 5.7833 15.93 6.84664 15.93C7.90247 15.93 8.20164 16.4992 9.12997 16.4767C10.0733 16.4617 10.6725 15.6233 11.2483 14.7775C11.915 13.8042 12.1916 12.8608 12.2066 12.8083C12.1841 12.8008 10.3725 12.105 10.35 10.0083C10.335 8.25666 11.78 7.41833 11.8475 7.38083C11.0241 6.17583 9.75914 6.04083 9.31747 6.01083C8.16414 5.92083 7.19914 6.64 6.65997 6.64V6.64Z"
        stroke="#323232"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.3755 1.46198C9.09965 1.19238 9.57333 1.58988 9.43352 2.34982C9.2937 3.10977 8.59332 3.94438 7.86918 4.21398C7.14504 4.48358 6.67136 4.08608 6.81117 3.32613C6.95099 2.56619 7.65137 1.73158 8.3755 1.46198"
        stroke="#323232"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
function LinuxIcon() {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="21" height="21" fill="#252C32" />
      <rect
        x="-1325"
        y="-1645"
        width="2516.51"
        height="2183.99"
        fill="#F5F5FD"
      />
      <rect
        x="-310.994"
        y="-1550.77"
        width="363.387"
        height="1907.8"
        rx="20"
        fill="white"
      />
      <mask id="path-3-inside-1_2861_9312" fill="white">
        <path d="M4.25691 18.4662C5.23226 18.5795 6.32815 19.1945 7.24526 19.3031C8.1673 19.4164 8.45263 18.6919 8.45263 18.6919C8.45263 18.6919 9.49022 18.4662 10.581 18.4402C11.6729 18.4104 12.7065 18.6612 12.7065 18.6612C12.7065 18.6612 12.907 19.108 13.2811 19.3031C13.6553 19.5019 14.4608 19.5288 14.9771 18.9994C15.4944 18.4662 16.8746 17.7944 17.6496 17.3746C18.4295 16.9537 18.2863 16.3119 17.7967 16.1168C17.3071 15.9218 16.9062 15.6143 16.9368 15.0243C16.9635 14.4391 16.5044 14.049 16.5044 14.049C16.5044 14.049 16.9062 12.7615 16.5321 11.6949C16.1579 10.6332 14.9239 8.92571 13.9752 7.642C13.0265 6.35445 13.832 4.868 12.9683 2.96834C12.1044 1.06583 9.86443 1.17829 8.65706 1.9892C7.44969 2.80017 7.81985 4.81125 7.87809 5.76543C7.93633 6.71474 7.90475 7.39405 7.7932 7.63817C7.68165 7.88605 6.90274 8.7864 6.38545 9.54068C5.86915 10.2988 5.49493 11.8641 5.11684 12.5098C4.74661 13.1517 5.00529 13.7368 5.00529 13.7368C5.00529 13.7368 4.74667 13.8233 4.5423 14.2442C4.34187 14.6602 3.94105 14.8591 3.21939 14.9946C2.50265 15.1378 2.50265 15.5875 2.67544 16.091C2.84916 16.5935 2.67544 16.875 2.475 17.5169C2.27462 18.1587 3.27763 18.3537 4.25691 18.4662ZM14.3957 15.5383C14.908 15.7564 15.6445 15.4528 15.8686 15.2347C16.0918 15.0175 16.2497 14.6947 16.2497 14.6947C16.2497 14.6947 16.4738 14.8033 16.4511 15.1482C16.4273 15.4979 16.6051 15.9966 16.9407 16.1696C17.2764 16.3416 17.7887 16.5818 17.5232 16.822C17.2526 17.0622 15.7561 17.6483 15.3089 18.1057C14.8656 18.5602 14.2831 18.932 13.9287 18.8225C13.5704 18.7139 13.2574 18.2374 13.4115 17.5398C13.5704 16.8451 13.7047 16.0831 13.6819 15.6478C13.6583 15.2126 13.5704 14.6264 13.6819 14.5399C13.7935 14.4544 13.9712 14.4957 13.9712 14.4957C13.9712 14.4957 13.8823 15.3212 14.3957 15.5383ZM11.0708 3.77931C11.5643 3.77931 11.9622 4.25588 11.9622 4.842C11.9622 5.25805 11.7618 5.6184 11.4686 5.79137C11.3945 5.7616 11.3175 5.72794 11.2326 5.69331C11.4103 5.60783 11.5337 5.38971 11.5337 5.13794C11.5337 4.8084 11.3254 4.53743 11.0638 4.53743C10.8091 4.53743 10.5968 4.80834 10.5968 5.13794C10.5968 5.25811 10.6274 5.37817 10.6777 5.47234C10.5237 5.41177 10.3845 5.35994 10.273 5.31863C10.2148 5.17543 10.1802 5.014 10.1802 4.84205C10.1802 4.25594 10.5771 3.77931 11.0708 3.77931ZM9.84852 5.61074C10.0914 5.65205 10.7587 5.9336 11.0056 6.02005C11.2524 6.10268 11.5258 6.2564 11.4992 6.41017C11.4686 6.56868 11.3412 6.56868 11.0056 6.7676C10.6739 6.96268 9.94927 7.39794 9.71725 7.42771C9.48622 7.45748 9.35495 7.33062 9.10807 7.17594C8.86125 7.01834 8.39832 6.65034 8.51475 6.45531C8.51475 6.45531 8.87705 6.18531 9.03504 6.04697C9.19302 5.90377 9.60171 5.56651 9.84852 5.61074ZM8.78428 3.94845C9.17324 3.94845 9.49016 4.39908 9.49016 4.95446C9.49016 5.05537 9.4783 5.14948 9.45957 5.24365C9.36281 5.27343 9.26612 5.32246 9.17324 5.40125C9.12786 5.43874 9.08535 5.47234 9.0469 5.50983C9.10807 5.39743 9.13179 5.236 9.10414 5.06685C9.05083 4.76708 8.84253 4.54514 8.63816 4.57491C8.43279 4.60857 8.31038 4.88337 8.35975 5.18703C8.41406 5.49451 8.61837 5.7164 8.82667 5.6828C8.83853 5.67897 8.84939 5.67514 8.86125 5.67125C8.76156 5.76543 8.66874 5.84805 8.57199 5.91531C8.29065 5.78748 8.08235 5.40508 8.08235 4.95446C8.08241 4.39526 8.39433 3.94845 8.78428 3.94845ZM6.61735 11.2183C7.01817 10.6034 7.27678 9.25914 7.6776 8.81234C8.08241 8.36651 8.39433 7.41622 8.25219 6.99634C8.25219 6.99634 9.116 8.00234 9.71725 7.83708C10.3194 7.66794 11.6729 6.68885 11.8733 6.85703C12.0738 7.02611 13.7974 10.7158 13.9711 11.891C14.1449 13.0651 13.8557 13.9626 13.8557 13.9626C13.8557 13.9626 13.1962 13.7935 13.1113 14.1836C13.0264 14.5775 13.0264 16.0044 13.0264 16.0044C13.0264 16.0044 12.1349 17.2055 10.7548 17.4044C9.37461 17.5995 8.68354 17.4572 8.68354 17.4572L7.90856 16.5934C7.90856 16.5934 8.51081 16.507 8.42586 15.9179C8.34096 15.3328 6.58565 14.5218 6.26973 13.7934C5.95393 13.0651 6.21161 11.8342 6.61735 11.2183ZM3.20453 15.6248C3.27363 15.3366 4.16802 15.3366 4.5116 15.1339C4.85517 14.9311 4.92421 14.3489 5.20167 14.1951C5.47509 14.0375 5.98058 14.5968 6.18889 14.9119C6.39326 15.2194 7.17616 16.5636 7.49601 16.898C7.81979 17.2352 8.11699 17.682 8.02416 18.0837C7.93633 18.4853 7.44963 18.7784 7.44963 18.7784C7.01429 18.9091 5.79999 18.3988 5.24817 18.174C4.69636 17.9482 3.29248 17.8809 3.11183 17.682C2.92625 17.4793 3.20066 17.0325 3.27369 16.6087C3.3388 16.1802 3.13449 15.914 3.20453 15.6248Z" />
      </mask>
      <path
        d="M4.25691 18.4662C5.23226 18.5795 6.32815 19.1945 7.24526 19.3031C8.1673 19.4164 8.45263 18.6919 8.45263 18.6919C8.45263 18.6919 9.49022 18.4662 10.581 18.4402C11.6729 18.4104 12.7065 18.6612 12.7065 18.6612C12.7065 18.6612 12.907 19.108 13.2811 19.3031C13.6553 19.5019 14.4608 19.5288 14.9771 18.9994C15.4944 18.4662 16.8746 17.7944 17.6496 17.3746C18.4295 16.9537 18.2863 16.3119 17.7967 16.1168C17.3071 15.9218 16.9062 15.6143 16.9368 15.0243C16.9635 14.4391 16.5044 14.049 16.5044 14.049C16.5044 14.049 16.9062 12.7615 16.5321 11.6949C16.1579 10.6332 14.9239 8.92571 13.9752 7.642C13.0265 6.35445 13.832 4.868 12.9683 2.96834C12.1044 1.06583 9.86443 1.17829 8.65706 1.9892C7.44969 2.80017 7.81985 4.81125 7.87809 5.76543C7.93633 6.71474 7.90475 7.39405 7.7932 7.63817C7.68165 7.88605 6.90274 8.7864 6.38545 9.54068C5.86915 10.2988 5.49493 11.8641 5.11684 12.5098C4.74661 13.1517 5.00529 13.7368 5.00529 13.7368C5.00529 13.7368 4.74667 13.8233 4.5423 14.2442C4.34187 14.6602 3.94105 14.8591 3.21939 14.9946C2.50265 15.1378 2.50265 15.5875 2.67544 16.091C2.84916 16.5935 2.67544 16.875 2.475 17.5169C2.27462 18.1587 3.27763 18.3537 4.25691 18.4662ZM14.3957 15.5383C14.908 15.7564 15.6445 15.4528 15.8686 15.2347C16.0918 15.0175 16.2497 14.6947 16.2497 14.6947C16.2497 14.6947 16.4738 14.8033 16.4511 15.1482C16.4273 15.4979 16.6051 15.9966 16.9407 16.1696C17.2764 16.3416 17.7887 16.5818 17.5232 16.822C17.2526 17.0622 15.7561 17.6483 15.3089 18.1057C14.8656 18.5602 14.2831 18.932 13.9287 18.8225C13.5704 18.7139 13.2574 18.2374 13.4115 17.5398C13.5704 16.8451 13.7047 16.0831 13.6819 15.6478C13.6583 15.2126 13.5704 14.6264 13.6819 14.5399C13.7935 14.4544 13.9712 14.4957 13.9712 14.4957C13.9712 14.4957 13.8823 15.3212 14.3957 15.5383ZM11.0708 3.77931C11.5643 3.77931 11.9622 4.25588 11.9622 4.842C11.9622 5.25805 11.7618 5.6184 11.4686 5.79137C11.3945 5.7616 11.3175 5.72794 11.2326 5.69331C11.4103 5.60783 11.5337 5.38971 11.5337 5.13794C11.5337 4.8084 11.3254 4.53743 11.0638 4.53743C10.8091 4.53743 10.5968 4.80834 10.5968 5.13794C10.5968 5.25811 10.6274 5.37817 10.6777 5.47234C10.5237 5.41177 10.3845 5.35994 10.273 5.31863C10.2148 5.17543 10.1802 5.014 10.1802 4.84205C10.1802 4.25594 10.5771 3.77931 11.0708 3.77931ZM9.84852 5.61074C10.0914 5.65205 10.7587 5.9336 11.0056 6.02005C11.2524 6.10268 11.5258 6.2564 11.4992 6.41017C11.4686 6.56868 11.3412 6.56868 11.0056 6.7676C10.6739 6.96268 9.94927 7.39794 9.71725 7.42771C9.48622 7.45748 9.35495 7.33062 9.10807 7.17594C8.86125 7.01834 8.39832 6.65034 8.51475 6.45531C8.51475 6.45531 8.87705 6.18531 9.03504 6.04697C9.19302 5.90377 9.60171 5.56651 9.84852 5.61074ZM8.78428 3.94845C9.17324 3.94845 9.49016 4.39908 9.49016 4.95446C9.49016 5.05537 9.4783 5.14948 9.45957 5.24365C9.36281 5.27343 9.26612 5.32246 9.17324 5.40125C9.12786 5.43874 9.08535 5.47234 9.0469 5.50983C9.10807 5.39743 9.13179 5.236 9.10414 5.06685C9.05083 4.76708 8.84253 4.54514 8.63816 4.57491C8.43279 4.60857 8.31038 4.88337 8.35975 5.18703C8.41406 5.49451 8.61837 5.7164 8.82667 5.6828C8.83853 5.67897 8.84939 5.67514 8.86125 5.67125C8.76156 5.76543 8.66874 5.84805 8.57199 5.91531C8.29065 5.78748 8.08235 5.40508 8.08235 4.95446C8.08241 4.39526 8.39433 3.94845 8.78428 3.94845ZM6.61735 11.2183C7.01817 10.6034 7.27678 9.25914 7.6776 8.81234C8.08241 8.36651 8.39433 7.41622 8.25219 6.99634C8.25219 6.99634 9.116 8.00234 9.71725 7.83708C10.3194 7.66794 11.6729 6.68885 11.8733 6.85703C12.0738 7.02611 13.7974 10.7158 13.9711 11.891C14.1449 13.0651 13.8557 13.9626 13.8557 13.9626C13.8557 13.9626 13.1962 13.7935 13.1113 14.1836C13.0264 14.5775 13.0264 16.0044 13.0264 16.0044C13.0264 16.0044 12.1349 17.2055 10.7548 17.4044C9.37461 17.5995 8.68354 17.4572 8.68354 17.4572L7.90856 16.5934C7.90856 16.5934 8.51081 16.507 8.42586 15.9179C8.34096 15.3328 6.58565 14.5218 6.26973 13.7934C5.95393 13.0651 6.21161 11.8342 6.61735 11.2183ZM3.20453 15.6248C3.27363 15.3366 4.16802 15.3366 4.5116 15.1339C4.85517 14.9311 4.92421 14.3489 5.20167 14.1951C5.47509 14.0375 5.98058 14.5968 6.18889 14.9119C6.39326 15.2194 7.17616 16.5636 7.49601 16.898C7.81979 17.2352 8.11699 17.682 8.02416 18.0837C7.93633 18.4853 7.44963 18.7784 7.44963 18.7784C7.01429 18.9091 5.79999 18.3988 5.24817 18.174C4.69636 17.9482 3.29248 17.8809 3.11183 17.682C2.92625 17.4793 3.20066 17.0325 3.27369 16.6087C3.3388 16.1802 3.13449 15.914 3.20453 15.6248Z"
        fill="black"
        stroke="black"
        stroke-width="2"
        mask="url(#path-3-inside-1_2861_9312)"
      />
    </svg>
  );
}

function PrinterIcon(props) {
  return (
    <Logo
      className="module-logo"
      url={`${envConfig.imageRoot}svg/printer.png`}
    />
  );
}

export {
  ProductOnboard,
  Approvals,
  ChatBackdrop,
  Updates,
  Conversation,
  Notes,
  Tasks,
  Invoice,
  Invoices,
  Quotes,
  InvoiceAudit,
  Attachments,
  Clients,
  UnkownEmail,
  Asset,
  MyWorkspace,
  Project,
  Search,
  Close,
  Ticket,
  Task,
  Script,
  Alert,
  Patch,
  ItDocumantation,
  SLAOverdueTimer,
  Reports,
  Charts,
  TicketTabIcon,
  AssetsTabIcon,
  ChartTabIcon,
  ReportTabIcon,
  ProjectTabIcon,
  ClientTabIcon,
  ITDocsTabIcon,
  FeedBackIcon,
  MoreTabsIcon,
  ScriptsTabIcon,
  TabsCloseIcon,
  NewAlertTabIcon,
  NewPatchTabIcon,
  NewAssetTabIcon,
  SiteTabIcon,
  RequesterTabIcon,
  ContractTemplate,
  MacIcon,
  MailTabIcon,
  WindowsIcon,
  HomeTabIcon,
  Logo,
  ITDocumentationTabIcon,
  SettingsIcon,
  ClientHomeTabIcon,
  QuickBooks,
  XeroBlue,
  ServiceItem,
  ModuleLogo,
  CommunityScriptTabIcon,
  RefreshIcon,
  MigrateData,
  NetworkMonitorIcon,
  LinuxIcon,
  PrinterIcon,
  TimesheetData,
  SchedulingData,
  InsightTabIcon
};
